<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UEUheT/CoverDesign.jpg?1684515368311" alt="This image is the cover for the book Shifter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shifter
      </h1>
      <p class="bookDescription body article font2">
        <p>When Gray Fox sets out by canoe to visit Elk Horn, his childhood friend and secret crush, mysterious forces strand him on a terrifying hunk of ebony rock known as Black Island. During the dark, cold night, a strangely androgynous being seduces the young virgin. In the midst of his passion, the creature shifts into a comely youth, shocking the naïve young man. He can hardly wait to tell Elk Horn about the experience. But does he dare?</p><p><i>A story from the Dreamspinner Press 2016 Daily Dose package "A Walk on the Wild Side."</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Wildyr
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df82c500